export default "__VITE_ASSET__ea09e0a2__"